import { styled } from "@mui/material";

const AutoplayVideoElement = styled("video")({
  display: "block",
  width: "100%",
  height: "auto",
});

export default AutoplayVideoElement;
